import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import Debounce from 'lodash-decorators/debounce';

import Document from 'common/components/Document/Document';

import styles from './TwoColumnsAccordionPanel.module.scss';

export default class TwoColumnsAccordionPanel extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    panels: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired
  };

  state = {
    height: null
  };

  panelRef = createRef();
  containerRef = createRef();

  componentDidMount() {
    window.addEventListener('resize', () => this.updateDimensions());
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this.updateDimensions());
  }

  @Debounce(200)
  updateDimensions() {
    this.setState({
      height: this.containerRef.current.scrollHeight
    });
  }

  render() {
    const activePanelClass = this.props.isOpen ? styles.PanelActive : '';
    const activePanelButtonClass = this.props.isOpen
      ? styles.PanelButtonActive
      : '';

    const { isOpen, onClose, panels, title } = this.props;

    return (
      <li>
        <button
          className={`${styles.PanelButton} ${activePanelButtonClass}`}
          onClick={onClose}
        >
          {title}
        </button>
        <div
          ref={this.panelRef}
          style={
            isOpen
              ? {
                  height: this.panelRef.current ? this.state.height : '0px'
                }
              : { height: '0px' }
          }
          className={`${styles.Panel} ${activePanelClass}`}
        >
          <div ref={this.containerRef} className={styles.Container}>
            {panels.map((panel, index) => (
              <div key={panel.id}>
                <h2>{panel.title}</h2>
                <div
                  className={
                    index === 1
                      ? styles.GridItemHeaderRight
                      : styles.GridItemHederLeft
                  }
                  dangerouslySetInnerHTML={{
                    __html: panel.description
                  }}
                />
              </div>
            ))}
            {panels.map(
              (panel, index) =>
                Boolean(panel.file.length) && (
                  <div
                    key={panel.id}
                    className={
                      index === 1
                        ? styles.GridItemBodyRight
                        : styles.GridItemBodyLeft
                    }
                  >
                    {panel.file.map(document => (
                      <Document key={document.system.id} document={document} />
                    ))}
                  </div>
                )
            )}
          </div>
        </div>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AccordionList/components/TwoColumnsAccordionPanel/TwoColumnsAccordionPanel.js